import { formatDateTime } from '../dates';

// The one-entry Excel file, built with ExcelJS (passed in, so the library
// is loaded only when someone downloads and tests can hand in a fake). The
// full submissions export is built by the worker (pitpay-go).

const NAVY = { argb: 'FF1F2A30' };
const GRAY = { argb: 'FF64748B' };
const ORANGE_TEXT = { argb: 'FFD63A0F' };
const ORANGE = { argb: 'FFFA4616' };
const LINE = { argb: 'FFE2E8F0' };

export const XLSX_TYPE =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

// Excel sheet names: 31 characters, none of []:*?/\
export const sheetName = (name, fallback = 'Sheet1') =>
  String(name || '')
    .replace(/[[\]:*?/\\]/g, '-')
    .trim()
    .slice(0, 31) || fallback;

// One entry, one row per field (Implementation List §2 "Excel (one
// entry)"). rows: [{ section } | { k, v }] in form order; images: PNG data
// URLs for the account logo (or its monogram) and the platform logo, either
// may be null.
export const buildEntryWorkbook = (
  ExcelJS,
  { brand, formName, entry, rows, images = {} }
) => {
  const wb = new ExcelJS.Workbook();
  wb.creator = `ticketOS · ${brand.platform}`;
  const ws = wb.addWorksheet(sheetName(entry.reference, 'Entry'), {
    views: [{ showGridLines: false }],
  });
  ws.getColumn(1).width = 34;
  ws.getColumn(2).width = 64;

  ws.getRow(1).height = 46;
  const place = (dataUrl, col) => {
    if (!dataUrl) return;
    const id = wb.addImage({ base64: dataUrl, extension: 'png' });
    ws.addImage(id, {
      tl: { col, row: 0.12 },
      ext: { width: 50, height: 50 },
    });
  };
  place(images.track, 0.04);
  place(images.platform, 1.86);

  const account = ws.getRow(2);
  account.getCell(1).value = brand.name || 'Unassigned account';
  account.getCell(1).font = { bold: true, size: 15, color: NAVY };
  account.getCell(2).value = `Powered by ${brand.platform}`;
  account.getCell(2).font = { size: 10, color: GRAY };
  account.getCell(2).alignment = { horizontal: 'right' };

  const form = ws.getRow(3);
  form.getCell(1).value = formName;
  form.getCell(1).font = { size: 10, color: GRAY };
  ws.mergeCells('A3:B3');
  ['A3', 'B3'].forEach((address) => {
    ws.getCell(address).border = {
      bottom: { style: 'medium', color: ORANGE },
    };
  });

  let r = 5;
  const pair = (label, value, bold) => {
    const row = ws.getRow(r);
    r += 1;
    row.getCell(1).value = label;
    row.getCell(1).font = { bold: true, size: 10, color: GRAY };
    row.getCell(1).alignment = { vertical: 'top' };
    row.getCell(2).value = value || '—';
    row.getCell(2).font = {
      size: 11,
      color: value ? NAVY : GRAY,
      bold: !!bold,
    };
    row.getCell(2).alignment = { wrapText: true, vertical: 'top' };
    [1, 2].forEach((c) => {
      row.getCell(c).border = { bottom: { style: 'thin', color: LINE } };
    });
  };

  pair('Entry ID', entry.reference, true);
  pair('Submitted', formatDateTime(entry.submitted_at));
  rows.forEach((item) => {
    if (item.section) {
      r += 1;
      const row = ws.getRow(r);
      r += 1;
      row.getCell(1).value = String(item.section).toUpperCase();
      row.getCell(1).font = { bold: true, size: 10, color: ORANGE_TEXT };
      return;
    }
    pair(item.k, item.v);
  });
  return wb;
};

// Resolves to the workbook as a Blob ready to download.
export const workbookBlob = async (wb) =>
  new Blob([await wb.xlsx.writeBuffer()], { type: XLSX_TYPE });
